import callRefFunc from 'src/utils/callRefFunc';
import isoDateToLocaleDate from 'src/utils/dateOperations/isoDateToLocaleDate';
import Vue from 'vue';
export default Vue.extend({
    props: {
        // @ts-expect-error
        value: { type: String },
        label: { type: String },
        inputHandler: { type: Function },
        qInputProps: { type: Object },
        qInputClasses: { type: String },
        qDateProps: { type: Object },
        showIconOnlyOnHover: { type: Boolean, default: false }
    },
    computed: {
        iconClasses() {
            return 'cursor-pointer ' + this.showIconOnlyOnHover ? 'show-on-hover' : '';
        },
        formattedValue() {
            return this.value && isoDateToLocaleDate(this.value, { dateStyle: 'medium' });
        }
    },
    methods: {
        handleInput(newVal, oldVal) {
            this.$emit('input', newVal);
            if (typeof this.inputHandler === 'function')
                this.inputHandler(newVal);
            callRefFunc(this, 'qDatePopupProxy', 'hide');
        }
    }
});
